export const DateFormats = {
  Data: 'yyyy-MM-ddTHH:mm:ssZZZZZ',
  DateTime: 'dd MMM yyyy HH:mm',
  Date: 'dd MMM yyyy',
  Day: 'EEE dd MMM yyyy',
  Time: 'HH:mm'
}
